export default function PillIcon({ width = 16, height = 16, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.38 1.483a5.035 5.035 0 0 1 7.137 0 5.035 5.035 0 0 1 0 7.136L8.62 12.517a5.035 5.035 0 0 1-7.136 0 5.035 5.035 0 0 1 0-7.136zM2.745 6.64a3.25 3.25 0 0 0 0 4.616 3.25 3.25 0 0 0 4.615 0l2.123-2.124-4.615-4.615zm8.363-3.963a3.16 3.16 0 0 0-4.447 0l.84.84a1.97 1.97 0 0 1 2.767 0l.42-.42z'
      />
    </svg>
  );
}
